import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../App.css";
import { apiPostAuth } from "../../utils/api";
import toast from "react-hot-toast";

export default function LoanQueuePage() {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [queueList, setQueueList] = useState([]);
  const [memberList, setMemberList] = useState([]);

  const [addModal, setAddModal] = useState(false);

  const [selectedMemberId, setSelectedMemberId] = useState("");
  const [loanAmount, setLoanAmount] = useState("");
  const [interestRate, setInterestRate] = useState(10);
  const [paymentTerm, setPaymentTerm] = useState(2);
  const [queueDate, setQueueDate] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    fetchQueueList();
  }, []);

  const fetchQueueList = async () => {
    try {
      const response = await apiPostAuth(
        "loan/queue_list.php"
      );

      if (response.result === 1) {
        setQueueList(response.queue_list || []);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const fetchMemberList = async () => {
    try {
      const response = await apiPostAuth(
        "member/queue_member_list.php"
      );

      if (response.result === 1) {
        setMemberList(response.member_list || []);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const formatCurrency = (value) => {
    return Number(value || 0).toLocaleString(
      "id-ID",
      {
        style: "currency",
        currency: "IDR",
        maximumFractionDigits: 0,
      }
    );
  };

  const formatDate = (dateString) => {
    if (!dateString || dateString.length < 14)
      return "-";

    const year = dateString.slice(0, 4);
    const month = dateString.slice(4, 6);
    const day = dateString.slice(6, 8);
    const hour = dateString.slice(8, 10);
    const minute = dateString.slice(10, 12);

    const date = new Date(
      `${year}-${month}-${day}T${hour}:${minute}:00`
    );

    return date.toLocaleString("id-ID", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const handleDeleteQueue = async (
    queueId
  ) => {
    const confirmed = window.confirm(
      "Delete this queue?"
    );

    if (!confirmed) {
      return;
    }

    const toastId = toast.loading(
      "Deleting queue..."
    );

    try {
      const response = await apiPostAuth(
        "loan/delete_queue.php",
        {
          queue_id: queueId,
        }
      );

      if (response.result === 1) {
        toast.success(
          "Berhasil menghapus antrian.",
          {
            id: toastId,
          }
        );

        fetchQueueList();
      } else {
        toast.error(
          response.message ||
            "Gagal menghapus antrian.",
          {
            id: toastId,
          }
        );
      }
    } catch (error) {
      toast.error(
        "Gagal menghapus antrian.",
        {
          id: toastId,
        }
      );
    }
  };

  const openAddModal = async () => {
    setSelectedMemberId("");
    setLoanAmount("");
    setInterestRate(10);
    setPaymentTerm(2);
    setQueueDate(
      new Date().toISOString().slice(0, 10)
    );
    setErrorMessage("");

    await fetchMemberList();

    setAddModal(true);
  };

  const handleAddQueue = async () => {
    setErrorMessage("");

    if (!selectedMemberId) {
      setErrorMessage(
        "Please select member."
      );
      return;
    }

    if (
      !loanAmount ||
      Number(loanAmount) <= 0
    ) {
      setErrorMessage(
        "Please enter valid loan amount."
      );
      return;
    }

    if (!queueDate) {
      setErrorMessage(
        "Please select queue date."
      );
      return;
    }

    const toastId = toast.loading(
      "Adding queue..."
    );

    try {
      const response = await apiPostAuth(
        "loan/add_queue.php",
        {
          member_id: selectedMemberId,
          loan_amount: loanAmount,
          interest_rate: interestRate,
          payment_term: paymentTerm,
          queue_date: queueDate,
        }
      );

      if (response.result === 1) {
        toast.success(
          "Antrian telah ditambahkan.",
          {
            id: toastId,
          }
        );

        setAddModal(false);

        fetchQueueList();
      } else {
        toast.error(
          response.message ||
            "Gagal menambahkan antrian.",
          {
            id: toastId,
          }
        );

        setErrorMessage(
          response.message ||
            "Gagal menambahkan antrian."
        );
      }
    } catch (error) {
      toast.error(
        "Gagal menambahkan antrian.",
        {
          id: toastId,
        }
      );

      setErrorMessage(
        "Gagal menambahkan antrian."
      );
    }
  };

  const handleOpenCreateLoan = (
    memberId
  ) => {
    navigate(
      `/dashboard/loan/create/${memberId}`
    );
  };

  const handleOpenMember = (
    memberId
  ) => {
    navigate(
      `/dashboard/member/${memberId}`
    );
  };

  if (loading) {
    return (
      <div
        style={{
          textAlign: "center",
          marginTop: "50px",
        }}
      >
        <div className="loading-spinner"></div>
        <p>Memuat Antrian...</p>
      </div>
    );
  }

  return (
    <div style={{ padding: "20px" }}>
      <section style={sectionStyle}>
        <div style={headerContainerStyle}>
          <div>
            <h1 style={pageTitleStyle}>
              Antrian Pinjaman
            </h1>

            <p style={pageSubtitleStyle}>
              Atur antrian pinjaman yang akan datang diurutkan berdasarkan tanggal meminjam.
            </p>
          </div>

          <button
            onClick={openAddModal}
            className="primary-button"
          >
            Tambah Antrian
          </button>
        </div>

        {queueList.length === 0 ? (
          <div style={emptyBoxStyle}>
            <p
              style={{
                margin: 0,
                color: "#6b7280",
              }}
            >
              Belum ada antrian
            </p>
          </div>
        ) : (
          <div
            style={{
              display: "grid",
              gap: "14px",
            }}
          >
            {queueList.map((queue) => (
              <div
                key={queue.queue_id}
                style={queueCardStyle}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "15px",
                    flex: 1,
                  }}
                >
                  <img
                    src={
                      queue.member_profile_picture
                    }
                    alt={
                      queue.member_full_name
                    }
                    style={
                      memberImageStyle
                    }
                  />

                  <div style={{ flex: 1 }}>
                    <h3
                      style={{
                        margin: 0,
                        color: "#1f2937",
                      }}
                    >
                      {
                        queue.member_full_name
                      }
                    </h3>

                    <p
                      style={
                        loanAmountStyle
                      }
                    >
                      {formatCurrency(
                        queue.loan_amount
                      )}
                    </p>

                    <div
                      style={{
                        display: "flex",
                        gap: "14px",
                        flexWrap:
                          "wrap",
                        marginTop:
                          "8px",
                      }}
                    >
                      <p
                        style={
                          metaTextStyle
                        }
                      >
                        Bunga:{" "}
                        <strong>
                          {
                            queue.interest_rate
                          }
                          %
                        </strong>
                      </p>

                      <p
                        style={
                          metaTextStyle
                        }
                      >
                        Durasi Pinjaman:{" "}
                        <strong>
                          {
                            queue.payment_term
                          }{" "}
                          Bulan
                        </strong>
                      </p>

                      <p
                        style={
                          metaTextStyle
                        }
                      >
                        Tanggal Meminjam:{" "}
                        <strong>
                          {queue.queue_date}
                        </strong>
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection:
                      "column",
                    gap: "10px",
                  }}
                >
                  <button
                    onClick={() =>
                      handleOpenCreateLoan(
                        queue.member_id
                      )
                    }
                    className="primary-button"
                  >
                    Buat Pinjaman
                  </button>

                  <button
                    onClick={() =>
                      handleOpenMember(
                        queue.member_id
                      )
                    }
                    className="secondary-button"
                  >
                    Lihat Member
                  </button>

                  <button
                    onClick={() =>
                      handleDeleteQueue(
                        queue.queue_id
                      )
                    }
                    style={
                      deleteButtonStyle
                    }
                  >
                    Hapus Antrian
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </section>

      {addModal && (
        <div style={modalOverlayStyle}>
          <div style={modalContentStyle}>
            <h3 style={{ marginTop: 0 }}>
              Add Queue
            </h3>

            {errorMessage && (
              <p style={errorTextStyle}>
                {errorMessage}
              </p>
            )}

            <label style={labelStyle}>
              Member
            </label>

            <select
              value={selectedMemberId}
              onChange={(e) =>
                setSelectedMemberId(
                  e.target.value
                )
              }
              style={inputStyle}
            >
              <option value="">
                Select Member
              </option>

              {memberList.map(
                (member) => (
                  <option
                    key={
                      member.member_id
                    }
                    value={
                      member.member_id
                    }
                  >
                    {
                      member.full_name
                    }
                  </option>
                )
              )}
            </select>

            <label
              style={{
                ...labelStyle,
                marginTop: "15px",
              }}
            >
              Loan Amount
            </label>

            <MoneyInput
              value={loanAmount}
              onChange={(value) =>
                setLoanAmount(value)
              }
            />

            <label
              style={{
                ...labelStyle,
                marginTop: "15px",
              }}
            >
              Interest Rate
            </label>

            <input
              type="number"
              value={interestRate}
              onChange={(e) =>
                setInterestRate(
                  e.target.value
                )
              }
              style={inputStyle}
            />

            <label
              style={{
                ...labelStyle,
                marginTop: "15px",
              }}
            >
              Payment Term
            </label>

            <input
              type="number"
              min="2"
              value={paymentTerm}
              onChange={(e) =>
                setPaymentTerm(
                  e.target.value
                )
              }
              style={inputStyle}
            />

            <label
              style={{
                ...labelStyle,
                marginTop: "15px",
              }}
            >
              Queue Date
            </label>

            <input
              type="date"
              value={queueDate}
              onChange={(e) =>
                setQueueDate(
                  e.target.value
                )
              }
              style={inputStyle}
            />

            <div
              style={{
                marginTop: "20px",
              }}
            >
              <button
                onClick={
                  handleAddQueue
                }
                className="primary-button"
                style={{
                  marginRight:
                    "10px",
                  width: "100px",
                }}
              >
                Save
              </button>

              <button
                onClick={() =>
                  setAddModal(
                    false
                  )
                }
                className="secondary-button"
                style={{
                  width: "100px",
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function MoneyInput({
  value,
  onChange,
}) {
  return (
    <div style={moneyInputWrapperStyle}>
      <span style={moneyPrefixStyle}>
        Rp
      </span>

      <input
        type="number"
        value={value}
        onChange={(e) =>
          onChange(e.target.value)
        }
        style={moneyInputStyle}
        placeholder="0"
      />
    </div>
  );
}

/* Styles */

const sectionStyle = {
  backgroundColor: "#fff",
  padding: "22px",
  borderRadius: "12px",
  boxShadow:
    "0 2px 6px rgba(0,0,0,0.05)",
};

const headerContainerStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: "22px",
  gap: "15px",
  flexWrap: "wrap",
};

const pageTitleStyle = {
  margin: 0,
  fontSize: "1.8rem",
  color: "#1f2937",
};

const pageSubtitleStyle = {
  margin: "6px 0 0 0",
  color: "#6b7280",
};

const queueCardStyle = {
  backgroundColor: "#fff",
  border: "1px solid #e5e7eb",
  borderRadius: "12px",
  padding: "18px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "16px",
  boxShadow:
    "0 2px 4px rgba(0,0,0,0.04)",
  flexWrap: "wrap",
};

const memberImageStyle = {
  width: "62px",
  height: "62px",
  borderRadius: "50%",
  objectFit: "cover",
  border: "2px solid #e5e7eb",
  flexShrink: 0,
};

const loanAmountStyle = {
  margin: "8px 0 0 0",
  fontSize: "1.15rem",
  fontWeight: "700",
  color: "#111827",
};

const metaTextStyle = {
  margin: 0,
  fontSize: "0.9rem",
  color: "#6b7280",
};

const deleteButtonStyle = {
  border: "none",
  backgroundColor: "#fee2e2",
  color: "#dc2626",
  padding: "10px 14px",
  borderRadius: "8px",
  cursor: "pointer",
  fontWeight: "600",
};

const emptyBoxStyle = {
  padding: "25px",
  borderRadius: "12px",
  backgroundColor: "#f9fafb",
  border: "1px dashed #d1d5db",
  textAlign: "center",
};

const modalOverlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  backgroundColor:
    "rgba(0, 0, 0, 0.5)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1000,
  padding: "20px",
};

const modalContentStyle = {
  backgroundColor: "#fff",
  padding: "22px",
  borderRadius: "12px",
  boxShadow:
    "0 2px 10px rgba(0, 0, 0, 0.3)",
  width: "420px",
  maxWidth: "95%",
};

const labelStyle = {
  display: "block",
  marginBottom: "8px",
  color: "#1f2937",
  fontWeight: "500",
};

const inputStyle = {
  width: "100%",
  boxSizing: "border-box",
  padding: "10px",
  border: "1px solid #d1d5db",
  borderRadius: "8px",
  fontSize: "0.95rem",
};

const moneyInputWrapperStyle = {
  width: "100%",
  display: "flex",
  alignItems: "center",
  border: "1px solid #d1d5db",
  borderRadius: "8px",
  overflow: "hidden",
  backgroundColor: "#fff",
};

const moneyPrefixStyle = {
  padding: "10px 14px",
  backgroundColor: "#f9fafb",
  color: "#374151",
  fontWeight: "600",
  borderRight: "1px solid #d1d5db",
};

const moneyInputStyle = {
  flex: 1,
  padding: "10px",
  border: "none",
  outline: "none",
  fontSize: "0.95rem",
};

const errorTextStyle = {
  color: "#dc2626",
  fontSize: "0.9rem",
  marginBottom: "10px",
};